import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RenderingState, ErrorInfo } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const listStageApplicationsSlice = createSlice({
  name: 'LIST_STAGE_APPLICATIONS',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

//REDUCER
export default listStageApplicationsSlice.reducer;

// ACTIONS
export const { loading, success, failure } = listStageApplicationsSlice.actions;

/// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.job.listStageApplications.isLoading;

export const selectSuccess = (state: RootState) =>
  state.ui.job.listStageApplications.success;

export const selectError = (state: RootState) => state.ui.job.listStageApplications.error;
